import * as React from "react";

import { App } from "../../components/App";
import { InitialProps, createStore } from "../../store";

export function QueryHistoryViewerApp(props: InitialProps) {
  createStore(props);

  return <App />;
}
